import {Row, Col, Container, Form} from "react-bootstrap";
import React, {createRef, useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import refreshlogo from "../../assets/image/refresh.svg";

export default function DirectionOptionsModal(props) {
    const {isMobile} = useWindowDimensions();
    const {handleRefresh} = useContext(ActionPanelContext);
    const pageStatus = createRef();
    const [selectedDirection, setSelectedDirection] = useState(props.refreshCriteria.direction)

    const onRefreshClicked = () => {
        const onSuccess = () => {
        }
        const onError = () => {
        }

        props.refreshCriteria.direction = selectedDirection;
        handleRefresh(props.refreshCriteria, onSuccess, onError);
    }

    const onStatusDropdownChange = () => {
        setSelectedDirection(pageStatus.current.value)
        setGridApi(pageStatus.current.value)
    }

    const onRadioButtonChange = (e) => {
        setSelectedDirection(e.currentTarget.id)
        props.refreshCriteria.direction = e.currentTarget.id;
    }

    const onCancelButtonClicked = () => {
        props.setShow(false);
        props.setShowRefreshOptions(false);
        props.setShowDirectionOptions(false);
        props.setShowRightSideOptions(false);
    }

    const onApplyButtonClicked = () => {
        props.setShow(false);
        props.setShowRefreshOptions(false);
        props.setShowDirectionOptions(false);
        props.setShowRightSideOptions(false);
        setGridApi(selectedDirection)
    }

    const setGridApi = (direction) => {
        props.gridApi.setRowData(direction === "Any" ? props.rowData : props.rowData.filter(e => e.indDirection.trim().includes(direction)))
    }

    return (<>
        <Col style={{padding: 0, paddingLeft: 5, paddingRight: 10, textAlign: "center", alignSelf: "center"}}
             className={' d-none d-sm-block'}>
            <a href="#" style={{border: 'none', background: "none"}} className={"td-text-light"} onClick={onRefreshClicked}
            >
               Refresh
            </a>
        </Col>

        <Col style={{padding: 0, paddingRight: 20, textAlign: "center", alignSelf: "center"}}
             className="text-nowrap d-none d-sm-block">Direction</Col>

        <Col style={{padding: 0, paddingRight: 5}} className={' d-none d-sm-block'}>
            <Form.Control ref={pageStatus} as="select" className={'unset-custom-arrows'}
                          defaultValue="Any" onChange={onStatusDropdownChange}
                          style={{padding: 0, width: 'auto', height: 30}}
            >
                <option value={"Any"}>Any</option>
                <option value={"OUT"}>OUT</option>
                <option value={"IN"}>IN</option>
            </Form.Control>
        </Col>
        <Col md={4} xs={12} className={'p-0 m-0 d-md-none'}>
            <Container className="py-0">
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Check type="radio" id='Any' label='Any' checked={selectedDirection === 'Any'} name='direction'
                                className='m-0' onChange={onRadioButtonChange}/>
                    <Form.Check type="radio" id='OUT' label='OUT' checked={selectedDirection === 'OUT'}
                                name='direction' className='mt-2' onChange={onRadioButtonChange}/>
                    <Form.Check type="radio" id='IN' label='IN' checked={selectedDirection === 'CAPPR'}
                                name='direction' className='mt-2' onChange={onRadioButtonChange}/>
                    <Row className={"justify-content-center"}>
                        <Col md={4} xs={12} sm={12}>
                            <button href="#" className='btn btn-block td-btn-primary-light'
                                    onClick={onApplyButtonClicked}>Apply
                            </button>
                        </Col>
                        <Col md={4} xs={12} sm={12} className='md-pr-0 d-md-block'>
                            <button className='btn btn-block td-btn-secondary-clear' href="#" onClick={onCancelButtonClicked}>Cancel
                            </button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </Col>
    </>);
}
